module.exports = __webpack_public_path__ + "static/media/outline-insert_photo-24px.504ac7ce.svg";